export default "__VITE_PUBLIC_ASSET__692e40d4__"